module.exports = __webpack_public_path__ + "static/img/img_award_intro_table.6d43b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_award_intro_table.png
// module id = 4QJL
// module chunks = 1